import { useState, useEffect } from 'react';
import PermissionService from '../../../services/permission_service';

const Permissions = (props) => {
  const [permissions, setPermissions] = useState([]);

  const loadPermissions = async () => {
    try {
      props.setLoading(true);
      const permissionsData = await PermissionService.getAll()
      if (props.logout(permissionsData)) return;
      setPermissions(permissionsData || []);
    } catch (e) {
      props.message((e?.message || e), "error");
    } finally {
      props.setLoading(false);
    }
  };

  useEffect(() => {loadPermissions()}, []);

  const numberPermissions = (moduleId, actionId) => {
    return permissions.filter(perv => {
      return (
        (moduleId != null ? perv.FK_Module == moduleId : true) &&
        (actionId != null ? perv.FK_Action == actionId : true)
      )
    });
  };

  return numberPermissions;
};

export default Permissions;
